import React from 'react';
import randomstring from 'uuid/v4';
import TextField from '@material-ui/core/TextField';
import Switch from '@material-ui/core/Switch';
import { TrashIcon } from '../../../images/icons/WrapSvg';
import MultiSelectInput from '../../inputs/MultiSelectInput';
import BlueButton from '../../buttons/BlueButton';
import Back from './backstep';

function isNotOkEmail(value) {
    return value ? !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value) : false;
}

function init(id) {
    return {
        id: id,
        nombre: "",
        apellidos: "",
        email: "",
        documento: "",
        consentimiento: false,
        recibirAlertas: false,
        puesto: undefined,
        locales: []
    }
}

class Users extends React.Component {

    state = {
        isLoading: false,
        save: false,
        current: init(randomstring())
    }

    handleChangeCurrent = event => {
        const { current } = this.state;
        current[event.target.name] = event.target.value;
        this.setState({ current: JSON.parse(JSON.stringify(current)) })
    }

    handleCheckCurrent = event => {
        console.log(event.target.checked)
        const { current } = this.state;
        current[event.target.name] = event.target.checked;
        this.setState({ current: JSON.parse(JSON.stringify(current)) })
    }

    handleRoleChange = input => {
        console.log(input);
        const { current } = this.state;
        current['puesto'] = input.value;
        this.setState({ current: JSON.parse(JSON.stringify(current)) })
    }

    handleLocalesChange = input => {
        console.log(input);
        const { current } = this.state;
        current['locales'] = input.map((l) => l.value);
        this.setState({ current: JSON.parse(JSON.stringify(current)) })
    }

    handleAdd = event => {
        if (this.localReady()) {
            let { onboarding } = this.props;
            const { current } = this.state;
            if (!onboarding.usuarios) {
                onboarding.usuarios = [];
            }
            current.id = randomstring();
            onboarding.usuarios.push({ ...current });
            this.props.onSave('usuarios', onboarding.usuarios);
            this.setState({
                save: false,
                current: init(randomstring())
            })
        }
    }

    handleEdit = index => event => {
        this.setState({ save: index, current: this.props.onboarding.usuarios[index] })
    }

    handleSave = event => {
        let { onboarding } = this.props;
        const { current, save } = this.state;
        onboarding.usuarios[save] = current;
        this.props.onSave('usuarios', onboarding.usuarios);
        this.setState({
            save: false,
            current: JSON.parse(JSON.stringify(init(randomstring())))
        })
    }

    handleDelete = index => event => {
        let { onboarding } = this.props;
        onboarding.usuarios.splice(index, 1);
        this.props.onSave('usuarios', onboarding.usuarios);
        this.setState({
            save: false,
            current: JSON.parse(JSON.stringify(init(randomstring)))
        })
    }

    localReady = () => {
        const { current } = this.state;
        return current.nombre
            && current.email && !isNotOkEmail(current.email)
            && current.locales && current.locales.length > 0
            ;
    }


    render() {
        const { current, save } = this.state;
        const { intl, onboarding, quota } = this.props;
        const { usuarios, locales, roles } = onboarding;
        const localeslist = locales.map((t) => { return { label: t.nombre, value: t.id } });
        const roleslist = roles.map((t) => { return { label: t.nombre, value: t.id } });

        return (
            <div className="ob_step">
                <Back {...this.props} />
                <div className="flex_full_row padding_borders_flat center">
                    <div className="ob_welcome text_align_left_important">
                        <div className="flex_auto_row width100 ob_locals_email_message">
                            {intl.formatMessage({ id: 'ob_user_message' })}
                        </div>
                        <div className="ob_locals margin_top_24 padding_top_12">
                            {(usuarios && usuarios.length > 0) &&
                                usuarios.map((i, index) =>
                                    <div key={'user_bt_' + index} className="flex_auto_row margin_right_12">
                                        <div className="ob_local_button" onClick={this.handleEdit(index)}>
                                            <div className="flex_full_row width100 elements_from_right align_center margin_bottom_12">
                                                <div className="flex_full_row width100  ob_local_bt_index">
                                                    { roleslist.find((f) => f.value === i.puesto).label  }
                                                </div>
                                            </div>
                                            <span className="ob_local_button_title hand">{i.nombre}</span>
                                        </div>
                                        <div className="ob_trash">
                                            <TrashIcon
                                                className="hand ob_local_bt_trash"
                                                color={'secondary'}
                                                onClick={this.handleDelete(index)}
                                            />
                                        </div>
                                    </div>
                                )
                            }
                        </div>
                        <div className="flex_auto_row width100 align_baseline margin_top_24">
                            <TextField
                                fullWidth
                                id={'nombre'}
                                name={'nombre'}
                                required
                                label={intl.formatMessage({ id: 'form_field_name_nombre' })}
                                className={'flex_full_row margin_bottom_12'}
                                value={current.nombre ? current.nombre : ''}
                                onChange={this.handleChangeCurrent}
                                margin="normal"
                            />
                        </div>
                        <div className="flex_auto_row width100 align_baseline">
                            <TextField
                                fullWidth
                                id={'apellidos'}
                                name={'apellidos'}
                                label={intl.formatMessage({ id: 'form_field_name_apellidos' })}
                                className={'flex_full_row margin_bottom_12'}
                                value={current.apellidos ? current.apellidos : ''}
                                onChange={this.handleChangeCurrent}
                                margin="normal"
                            />
                        </div>
                        <div className="flex_auto_row width100 align_baseline ">
                            <TextField
                                fullWidth
                                id={'email'}
                                name={'email'}
                                required
                                error={isNotOkEmail(current.email)}
                                helperText={
                                    isNotOkEmail(current.email)
                                        ? intl.formatMessage({ id: 'email_format_error' })
                                        : ''
                                }
                                label={intl.formatMessage({ id: 'form_field_name_email' })}
                                className={'flex_full_row margin_bottom_12'}
                                value={current.email ? current.email : ''}
                                onChange={this.handleChangeCurrent}
                                margin="normal"
                            />
                        </div>
                        <div className="flex_auto_row width100 align_baseline">
                            <TextField
                                fullWidth
                                id={'documento'}
                                name={'documento'}
                                required
                                label={intl.formatMessage({ id: 'form_field_name_documento' })}
                                className={'flex_full_row margin_bottom_12'}
                                value={current.documento ? current.documento : ''}
                                onChange={this.handleChangeCurrent}
                                margin="normal"
                            />
                        </div>
                        <div className="flex_auto_row align_center margin_top_24">
                            <div className="flex_auto_column">
                                <Switch
                                    name={'recibirAlertas'}
                                    checked={current.recibirAlertas ? true : false}
                                    onChange={this.handleCheckCurrent}
                                    value="recibirAlertas"
                                    color="primary"
                                />
                            </div>
                            <div className="flex_full_row">
                                <div className="flex_auto_row select-input-label nowrap">
                                    {intl.formatMessage({ id: 'ob_sent_alerts' })}
                                </div>
                            </div>
                        </div>
                        <div className="flex_auto_row align_center margin_top_24">
                            <div className="flex_auto_column">
                                <Switch
                                    name={'consentimiento'}
                                    checked={current.consentimiento ? true : false}
                                    onChange={this.handleCheckCurrent}
                                    value="consentimiento"
                                    color="primary"
                                />
                            </div>
                            <div className="flex_full_row">
                                <div className="flex_auto_row select-input-label nowrap">
                                    {intl.formatMessage({ id: 'ob_consentimiento' })}
                                </div>
                            </div>
                        </div>
                        <div className="flex_auto_row width100 align_center margin_top_24 ">
                            <MultiSelectInput
                                defaultValue={[roleslist.find((f) => f.value === current['puesto'])]}
                                placeHolder={intl.formatMessage({
                                    id: 'ob_rol',
                                })}
                                options={roleslist}
                                onChange={this.handleRoleChange}
                                isSimple
                            />
                        </div>
                        <div className="flex_auto_row width100 align_center margin_top_24 ">
                            <MultiSelectInput
                                defaultValue={localeslist.filter((f) => current['locales'].indexOf(f.value) >= 0)}
                                placeHolder={intl.formatMessage({
                                    id: 'local',
                                })}
                                options={localeslist}
                                onChange={this.handleLocalesChange}
                            />
                        </div>
                        <div className="flex_auto_row width100 align_center elements_from_right">
                            {save !== false &&
                                <button className={"ob_add margin_right_12 " + (!this.localReady() ? 'c_disabled' : 'c_slate')} onClick={this.handleSave} >
                                    {intl.formatMessage({ id: 'ob_save' })}
                                </button>
                            }
                            {(!usuarios || !quota || (usuarios && usuarios.length < quota)) &&
                                <button className={"ob_add " + (!this.localReady() ? 'c_disabled' : 'c_slate')} onClick={this.handleAdd} >
                                    {intl.formatMessage({ id: 'ob_add' })}
                                </button>
                            }
                        </div>
                    </div>
                </div>
                <div className="flex_auto_row width100 padding_borders_flat elements_from_right">
                    <BlueButton id="next" className="ob_next" onClick={this.props.onNext} />
                </div>
            </div>

        );



    }
}

export default Users;


// WEBPACK FOOTER //
// ./src/components/complex/onboarding/users.js